module.exports = new __parcel__URL__("battlepass_claim_button_inactive.ae8d53da.png").toString();